<template>
  <div id="mapContainer">
    <l-map ref="map" id="map" :zoom="zoom" :center="center" :options="{ scrollWheelZoom: true }">
      <l-control-layers position="topright"></l-control-layers>
      <!-- <l-control position="topleft">
        <v-card class="d-flex flex-column pa-2 align-center">
          <v-card-title>Legend</v-card-title>
          <v-row>
            <v-col class="d-flex align-center">
              <div
                class="pa-2 blue darken-4 rounded-circle d-inline-block"
              ></div>
              <span class="pl-2">Automatic Cycle Counters</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex align-center">
              <div
                class="pa-2 red darken-4 rounded-circle d-inline-block"
              ></div>
              <span class="pl-2">Traffic Survey Areas</span>
            </v-col>
          </v-row>
        </v-card>
      </l-control> -->
      <LTileLayer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
      />
      <l-feature-group ref="LocationPopUpGroup">
        <l-popup>
          <div @click="requestScatterGraphData(point)">
            <span>Location: {{ currentHoverName }}</span>
          </div>
        </l-popup>
      </l-feature-group>
        <l-marker
          @mouseover="displayLocation(point, [point.latitude, point.longitude])"
          @click="requestScatterGraphData(point)"
          :key="index"
          v-for="(point, index) in fetchAutomaticCyclingCounters"
          :lat-lng="[point.latitude, point.longitude]"
        />
        <l-marker
          @mouseover="displayLocation(point, [point.Latitude, point.Longitude])"
          @click="requestLogarithmicGraphData(point)"
          :key="point['Street']"
          v-for="point in fetchTrafficSurveys"
          :lat-lng="[point.Latitude, point.Longitude]"
          :icon="getIcon()"
        />
    </l-map>
  </div>
</template>

<script>
import L from 'leaflet';
import {
  LMap, LTileLayer, LControlLayers, LFeatureGroup, LPopup, LMarker,
} from 'vue2-leaflet';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MapContainer',
  components: {
    LMap,
    LTileLayer,
    LControlLayers,
    LFeatureGroup,
    LPopup,
    LMarker,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 8,
      center: [56.538287, -3.902893],
      options: {
        scrollWheelZoom: true,
      },
      tileProviders: [
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
        {
          name: 'CycleOsm',
          visible: true,
          url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
          maxZoom: 20,
          attribution:
            '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        },
        {
          name: 'Esri World Imagery',
          visible: false,
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          maxZoom: 20,
          attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        },
      ],
      currentHoverName: null,
    };
  },
  methods: {
    ...mapActions(['requestScatterGraphData', 'requestLogarithmicGraphData']),
    displayLocation(data, coords) {
      this.currentHoverName = data.location ? data.location : data.Street;
      this.$refs.LocationPopUpGroup.mapObject.openPopup(coords);
    },
    getIcon() {
      return new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });
    },
  },
  computed: {
    ...mapGetters(['fetchAutomaticCyclingCounters', 'fetchTrafficSurveys', 'getBounds']),
    authority: {
      get() {
        return this.$store.state.map2.selectedAuthority;
      },
      set(val) {
        this.$store.commit('setAuthority', val);
      },
    },
    network: {
      get() {
        return this.$store.state.map2.selectedNetwork;
      },
    },
  },
  watch: {
    authority(newVal, oldVal) {
      if (oldVal !== newVal) {
        const bounds = this.getBounds;
        if (bounds) this.$refs.map.mapObject.setView(bounds.coords, bounds.zoom);
      }
    },
    network(newVal, oldVal) {
      if (oldVal !== newVal) {
        const bounds = this.getBounds;
        if (bounds) this.$refs.map.mapObject.setView(bounds.coords, bounds.zoom);
      }
    },
  },
};
</script>
<style lang="scss">
#map {
  position: relative;
  height: 100%
}

#mapContainer {
  height: 100%;
  z-index: 1;
}

.leaflet-popup {
  bottom: 15px !important
}
</style>
